<script lang="ts">
  import { BusinessUnit } from '$lib/careers/types';
  import { jobsFiltersStore } from '$lib/stores/Careers/jobFiltersStore';
  import BrandChip from './BrandChip.svelte';

  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { createEventDispatcher } from 'svelte';

  export let filterValues: string[];

  const dispatch = createEventDispatcher();

  const handleChange = (event: Event) => {
    let selected = [...$jobsFiltersStore.businessUnits];

    const value = (event.currentTarget as Element)?.getAttribute('data-value');
    if (value && selected.includes(value)) {
      selected = selected.filter((v) => v !== value);
    } else if (value) {
      selected = [...selected, value];
    }

    jobsFiltersStore.update((state) => ({
      ...state,
      businessUnits: selected
    }));

    dispatch('filters-change', $jobsFiltersStore);
  };

  const responsiveVars = new ResponsiveVars()
    .addFluid('chips-gap', toFluidVarInput(9, 9))
    .addFluid('legend-font-size', toFluidVarInput(18, 18))
    .addFluid('legend-mb', toFluidVarInput(12, 12))
    .toCSS();
</script>

<div class={responsiveVars}>
  <legend>
    Brands {$jobsFiltersStore.businessUnits.length > 0
      ? `(${$jobsFiltersStore.businessUnits.length})`
      : ''}
  </legend>
  <div class="chips">
    <!-- filter out bitkey from the bu's displayed in filters for now they are being listed under block / proto -->
    {#each Object.values(BusinessUnit).filter((b) => b != BusinessUnit.BITKEY) as bu}
      <BrandChip
        brand={bu}
        selected={$jobsFiltersStore.businessUnits.includes(bu)}
        disabled={!filterValues.includes(bu)}
        {handleChange}
      />
    {/each}
  </div>
</div>

<style lang="scss">
  @import 'src/scss/media';
  @import 'src/scss/variables';

  div {
    width: 100%;

    @include at('lg') {
      width: auto;
    }
  }

  .chips {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--chips-gap);

    @include at('lg') {
      flex-direction: row;
      gap: var(--chips-gap);
    }
  }

  legend {
    margin-bottom: var(--legend-mb);
    padding: 0;
    font-family: var(--font-family-primary);
    font-weight: 600;
    font-size: var(--legend-font-size);
    line-height: 180%;
    color: $text-default-color;

    @include at('lg') {
      display: none;
    }
  }
</style>
